/* eslint-disable no-underscore-dangle */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  dateContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '20vh',
    justifyContent: 'space-around',
  },
  alertContainer: {
    width: '100%',
    height: '60vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const NoExamDisplay = ({
  examText, getFormatedDate, examBegin, examEnd,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.alertContainer} aria-labelledby="exam-info-title">
      <Alert severity="info" role="status">
        {examText}
      </Alert>
      <div className={classes.dateContainer}>
        <Alert icon={false} variant="outlined" severity="info">
          {'Date de début : '}
          {getFormatedDate(examBegin)}
          <br />
          <br />
          {'Date de fin : '}
          {getFormatedDate(examEnd)}
        </Alert>
      </div>
    </div>
  );
};

NoExamDisplay.propTypes = {
  examText: PropTypes.string.isRequired,
  examBegin: PropTypes.instanceOf(Date).isRequired,
  examEnd: PropTypes.instanceOf(Date).isRequired,
  getFormatedDate: PropTypes.func.isRequired,
};

export default NoExamDisplay;
